import styled, { css } from 'styled-components';
import * as colors from '../../colors';
export const FormStyle = css `
  border-radius: 6px;
  background-color: #efefef;
  font-size: 16px;
  padding: 10px 10px;
  box-shadow: none;
  border: none;
  &::placeholder {
    color: ${colors.BLACK_7};
  }
  color: ${colors.FONT_SECONDARY};
`;
export const FormLargeStyle = css `
  padding: 14px 18px;
`;
export const Form = styled.input `
  ${FormStyle}
`;
export const Textarea = styled.textarea `
  border-radius: 4px;
  border-radius: 4px;
  background-color: #efefef;
  border: none;

  font-size: 16px;
  padding: 10px 14px;
  color: ${colors.FONT_SECONDARY};
  &::placeholder {
    /* color: ${colors.FONT_THIRD}; */
    color: #ddd;
  }
`;
export const WhiteForm = styled.input `
  border-radius: 4px;
  font-size: 22px;
  padding: 10px 0px;
  box-shadow: none;
  border: none;
  &::placeholder {
    /* color: ${colors.FONT_THIRD}; */
    color: #ddd;
  }
  color: ${colors.FONT_SECONDARY};
`;
export const BorderForm = styled.input `
  border-radius: 4px;
  font-size: 22px;
  padding: 0.1em 0em;
  box-shadow: none;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid #ddd;
  &::placeholder {
    /* color: ${colors.FONT_THIRD}; */
    color: #ddd;
  }
  color: ${colors.FONT_SECONDARY};
`;
export const CheckBoxMark = css `
  &:after {
    /*Add another block-level blank space*/
    content: '';
    display: block;
    margin-left: 7px;
    margin-top: 3px;

    /*Make it a small rectangle so the border will create an L-shape*/
    width: 5px;
    height: 11px;

    /*Add a white border on the bottom and left, creating that 'L' */
    border: solid #fff;
    border-width: 0 3px 3px 0;

    /*Rotate the L 45 degrees to turn it into a checkmark*/
    transform: rotate(45deg);
  }
`;
export const Checkbox = css `
  display: inline-block;
  width: 22px;
  height: 22px;
  border: 2px solid #dfdfdf;
  background-color: #dfdfdf;
  margin-right: 10px;
  border-radius: 50%;

  ${CheckBoxMark}

  &:hover {
    opacity: 0.6;
  }

  ${(props) => props.checked &&
    `
		background-color: ${colors.THEME_COLOR};
	  display:inline-block;
		border-color: ${colors.THEME_COLOR};
	`}
`;
